import { ChangeDetectionStrategy, Component, input, OnInit, viewChild, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from '@ngx-translate/core';
import { TranslationService } from '@services/translation.service';

@Component({
	selector: 'app-infoletter-header',
	templateUrl: './infoletter-header.component.html',
	styleUrl: './infoletter-header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, TranslatePipe]
})
export class InfoletterHeaderComponent implements OnInit {

	public infoletterDropdown = viewChild<NgbDropdown>("infoletterDropdown");
	public showLabel = input<boolean>(true);
	constructor(private translationService: TranslationService) { }

	ngOnInit(): void {
	}

	public onHoverDropdown() {
		this.infoletterDropdown().open()
	}

	public onLeaveDropdown() {
		this.infoletterDropdown().close()
	}

	public get infoletterUrl() {
		return `${this.translationService.getByKey('home.know-how.infoletter.link')}`;
	}
}
